export function getImportDate(value: string): Date | null {
  if (!value) return null;

  const [date, hours] = String(value).split(' ');

  let parseDate = date.split('/').reverse().join('-');
  parseDate += ` ${hours}`;

  return new Date(parseDate);
}
